export const REQUEST = 'Admin/Codes/REQUEST';
export const SUCCESS = 'Admin/Codes/SUCCESS';
export const ERROR = 'Admin/Codes/ERROR';

export const SET = 'Admin/Codes/SET';
export const DELETED = 'Admin/Codes/DELETED';
export const ADDED = 'Admin/Codes/ADDED';
export const UPDATED = 'Admin/Codes/UPDATED';
